export default __webpack_public_path__ + "static/media/M_Forms.b94495f5.png";